// extracted by mini-css-extract-plugin
export default {"childRemovalWrapper":"views-ContentPage-components-themes-BGH-popularCategories__childRemovalWrapper--b2Z7s"};